import(/* webpackMode: "eager" */ "/Users/tempalgin/Desktop/Projects/beztendera-dashboard-frontend/src/app/page.tsx");
